import react from "react";
import stateContext from "./StateContext";

const GlobalState = (props) => {
    const [fontNo, setFontNo] = react.useState("font1");
    const [fontId, setFontId] = react.useState("1");
    const [text, setText] = react.useState("Haref");
    const [selectedFontLanguage, setSelectedFontLanguage] =
        react.useState("English");
    const chain1Ref = react.useRef();
    const chain2Ref = react.useRef();
    const charmRef = react.useRef();

    const differenceRatio = react.useRef();
    let globalMaterial = null;
    const [finalPrice, setFinalPrice] = react.useState(0);
    const [chainSize, setChainSize] = react.useState("XSmall");

    const [pointArray, setPointArray] = react.useState([]);

    const [fontThickness, setFontThickness] = react.useState(1.02);
    const [globalUserText, setGlobalUserText] = react.useState("");
    const [globalTextModel, setGlobalTextModel] = react.useState(null);

    const [individualMeshes, setIndividualMeshes] = react.useState([]);

    const [color, setColor] = react.useState("#c4a73f");
    const [globalRoughness, setGlobalRoughness] = react.useState(0.15);
    const [globalMetalness, setGlobalMetalness] = react.useState(1);
    const [globalOffsetPathPoints, setGlobalOffsetPathPoints] = react.useState(
        []
    );

    const dotDiamondRef = react.useRef();
    const groupRef = react.useRef();
    const cameraRef = react.useRef();
    const controlsRef = react.useRef();
    const bloomRef = react.useRef();
    const [styleColor, setStyleColor] = react.useState(null);
    const [selectedCharm, setSelectedCharm] = react.useState("");
    const [charmColor, setCharmColor] = react.useState("White");
    const [noOfDotDiamond, setNoOfDotDiamond] = react.useState(0);
    const [textWeight, setTextWeight] = react.useState(0);
    const [chainWeight, setChainWeight] = react.useState(0);
    const [fontStyleColor, setFontStyleColor] = react.useState("");
    const [goldPrice, setGoldPrice] = react.useState(193.22);
    const [prices, setPrices] = react.useState({
        fontStylePrice: 0,
        styleColorPrice: 0,
        charmPrice: 0,
        chainPrice: 0,
        dotDiamondPrice: 0,
    });
    const [plateSize, setPlateSize] = react.useState(null);
    const [showDimension, setShowDimension] = react.useState(false);
    const [currentRawPlateSize, setCurrentRawPlateSize] = react.useState("");
    const [plateArea, setPlateArea] = react.useState(0);
    const [svgData, setSvgData] = react.useState(null);
    const [fonts, setFonts] = react.useState([]);
    const [chain, setChain] = react.useState([]);
    const [selectedFont, setSelectedFont] = react.useState(null);
    const [firstFontBuffers, setFirstFontBuffers] = react.useState({
        english: null,
        arabic: null,
    });
    const [selectedFontData, setSelectedFontData] = react.useState(null);
    const [selectedMetalData, setSelectedMetalData] = react.useState(null);
    const [priceDeviation, setPriceDeviation] = react.useState(0);
    const [selectedCharmData, setSelectedCharmData] = react.useState(null);
    const [selectedChainData, setSelectedChainData] = react.useState(null);
    const [activeTabIndex, setActiveTabIndex] = react.useState(0);
    const [diamondVisibilityMap, setDiamondVisibilityMap] = react.useState({});
    const [profit, setProfit] = react.useState(0);
    const [deviationData, setDeviationData] = react.useState({
        smallDeviation: 0,
        mediumDeviation: 0,
        largeDeviation: 0,
    });
    const [activeFontSizes, setActiveFontSizes] = react.useState({
        English: [],
        Arabic: [],
    });
    const [message, setMessage] = react.useState("");
    const [chainCharmDetails, setChainCharmDetails] = react.useState([]);
    const [activeCharm, setActiveCharm] = react.useState({
        charm: "",
        size: null,
    });

    const [chainCharmIndex, setChainCharmIndex] = react.useState(0);
    const [chainCharmSide, setChainCharmSide] = react.useState("None");

    const [chainCharmData, setChainCharmData] = react.useState({});
    const [dotDiamondData, setDotDiamondData] = react.useState(null);
    const [diamondPosData, setDiamondPosData] = react.useState([]);
    const [updateDiamondPos, setUpdateDiamondPos] = react.useState(false);
    const [diamondPosIndex, setDiamondPosIndex] = react.useState(null);
    const [chainCharmPrice, setChainCharmPrice] = react.useState(0);
    const [dotDiamondPrice, setDotDiamondPrice] = react.useState(0);
    const [addDotDiamond, setAddDotDiamond] = react.useState(false);
    const [activeDiamondSize, setActiveDiamondSize] = react.useState(null);
    const [hoveredDiamondIndex, setHoveredDiamondIndex] = react.useState(-1);
    const [hoveringDiamondData, setHoveringDiamondDiamondData] =
        react.useState(null);
    const [activeDiamondPrice, setActiveDiamondPrice] = react.useState(0);
    const [updatingDiamondIndex, setUpdatingDiamondIndex] =
        react.useState(null);
    const [charmColorName, setCharmColorName] = react.useState("White");
    const [allMetalData, setAllMetalData] = react.useState([]);
    const [diamondType, setDiamondType] = react.useState("");
    const [description, setDescription] = react.useState("");
    const [attachmentPricing, setAttachmentPricing] = react.useState({});
    const [diamondPrice, setDiamondPrice] = react.useState(0);
    const [pendantWeight, setPendantWeight] = react.useState(0);
    const [showMore, setShowMore] = react.useState(false);
    const [isMobileFullscreen, setIsMobileFullscreen] = react.useState(false);
    return (
        <stateContext.Provider
            value={{
                fontNo,
                setFontNo,
                setColor,
                text,
                setText,
                chain1Ref,
                chain2Ref,
                globalMaterial,
                chainSize,
                controlsRef,
                bloomRef,
                setChainSize,
                pointArray,
                setPointArray,
                fontThickness,
                setFontThickness,
                dotDiamondRef,
                differenceRatio,
                setGlobalRoughness,
                globalRoughness,
                cameraRef,
                charmRef,
                globalUserText,
                setGlobalUserText,
                globalTextModel,
                groupRef,
                globalOffsetPathPoints,
                color,
                setGlobalTextModel,
                setGlobalOffsetPathPoints,
                selectedFontLanguage,
                setSelectedFontLanguage,
                individualMeshes,
                setIndividualMeshes,
                styleColor,
                setStyleColor,
                selectedCharm,
                setSelectedCharm,
                charmColor,
                setCharmColor,
                noOfDotDiamond,
                setNoOfDotDiamond,
                fontStyleColor,
                setFontStyleColor,
                goldPrice,
                setGoldPrice,
                textWeight,
                setTextWeight,
                finalPrice,
                setFinalPrice,
                chainWeight,
                setChainWeight,
                prices,
                setPrices,
                globalMetalness,
                setGlobalMetalness,
                plateSize,
                setPlateSize,
                showDimension,
                setShowDimension,
                currentRawPlateSize,
                setCurrentRawPlateSize,
                plateArea,
                setPlateArea,
                svgData,
                setSvgData,
                fontSerialNo: fontId,
                setFontSerialNo: setFontId,
                fonts,
                setFonts,
                chain,
                setChain,
                selectedFont,
                setSelectedFont,
                firstFontBuffers,
                setFirstFontBuffers,
                selectedFontData,
                setSelectedFontData,
                selectedMetalData,
                setSelectedMetalData,
                priceDeviation,
                setPriceDeviation,
                selectedCharmData,
                setSelectedCharmData,
                selectedChainData,
                setSelectedChainData,
                activeTabIndex,
                setActiveTabIndex,
                diamondVisibilityMap,
                setDiamondVisibilityMap,
                profit,
                setProfit,
                deviationData,
                setDeviationData,
                activeFontSizes,
                setActiveFontSizes,
                message,
                setMessage,
                chainCharmDetails,
                setChainCharmDetails,
                activeCharm,
                setActiveCharm,
                chainCharmIndex,
                setChainCharmIndex,
                chainCharmSide,
                setChainCharmSide,
                chainCharmData,
                setChainCharmData,
                dotDiamondData,
                setDotDiamondData,
                diamondPosData,
                setDiamondPosData,
                updateDiamondPos,
                setUpdateDiamondPos,
                diamondPosIndex,
                setDiamondPosIndex,
                chainCharmPrice,
                setChainCharmPrice,
                dotDiamondPrice,
                setDotDiamondPrice,
                addDotDiamond,
                setAddDotDiamond,
                activeDiamondSize,
                setActiveDiamondSize,
                hoveredDiamondIndex,
                setHoveredDiamondIndex,
                hoveringDiamondData,
                setHoveringDiamondDiamondData,
                activeDiamondPrice,
                setActiveDiamondPrice,
                updatingDiamondIndex,
                setUpdatingDiamondIndex,
                charmColorName,
                setCharmColorName,
                allMetalData,
                setAllMetalData,
                diamondType,
                setDiamondType,
                description,
                setDescription,
                attachmentPricing,
                setAttachmentPricing,
                diamondPrice,
                setDiamondPrice,
                pendantWeight,
                setPendantWeight,
                showMore,
                setShowMore,
                isMobileFullscreen,
                setIsMobileFullscreen,
            }}
        >
            {props.children}
        </stateContext.Provider>
    );
};

export default GlobalState;
